import { useContext, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import {
  CapitalHarnessContext,
  SET_SHOW_HIDE_FORM_POPUP,
} from '../context/context'
import FileField from '../../../../common/FileField'
import { XCircle } from '@styled-icons/boxicons-solid'
import Button from '../../../../common/Button'
import { NavContext } from '../../../../../context/global_context'
import { postRequest } from '../../../../../services/base'
import { useParams } from 'react-router-dom'
import InputText from '../../../../common/InputText'
import TextArea from '../../../../common/TextArea'

const CapitalHarnessForm = ({
  getHarnessList,
  fetchCapHarnessStatusInterval,
}) => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(CapitalHarnessContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [selectedFiles, setSelectedFiles] = useState([
    {
      capital_harness_files: null,
      id: Math.random(),
      abbreviation: null,
      description: null,
      name: null,
    },
  ])

  const setFilesData = (file_name, value, index) => {
    let tempSelectedFiles = [...selectedFiles]
    tempSelectedFiles[index][file_name] = value
    setSelectedFiles(tempSelectedFiles)
  }

  const removeSelected = (index) => {
    let temp = [...selectedFiles]
    temp.splice(index, 1)
    setSelectedFiles(temp)
  }

  const uploadProgressFunction = (progressEvent) => {
    const totalLength = progressEvent.lengthComputable
      ? progressEvent.total
      : progressEvent.target.getResponseHeader('content-length') ||
        progressEvent.target.getResponseHeader('x-decompressed-content-length')

    const percentageCompleted = Math.round(
      (progressEvent.loaded * 100) / totalLength
    )
    if (percentageCompleted === 100) {
      navDispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
      setSelectedFiles([])
    }
  }

  const saveCapitalHarnessBulkUpload = async (e) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Capital Harness File upload is in progress, Don't Refresh Or close Window`,
        showLoader: true,
      },
      notification: {},
    })
    const form = e.target
    const formData = new FormData(form)
    let res = await postRequest(
      `/api/plugin/capital_harness/bulk/upload/${vehicle}/`,
      formData,
      false,
      {
        onUploadProgress: (progressEvent) => {
          uploadProgressFunction(progressEvent)
        },
      }
    )
    dispatch({ type: SET_SHOW_HIDE_FORM_POPUP, data: false })

    if (res?.status) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Successfully uploaded',
        },
      })

      setTimeout(() => {
        getHarnessList()
        fetchCapHarnessStatusInterval()
      }, 200)
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    }
  }

  return (
    <Modal
      onClose={() => {
        dispatch({ type: SET_SHOW_HIDE_FORM_POPUP, data: false })
      }}
      show={true}
      size={'w-3/4'}
    >
      <ModalHeader className={'text-white'}>
        Capital Harness File Upload
      </ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveCapitalHarnessBulkUpload(e)
          }}
        >
          <input
            type="hidden"
            value={selectedFiles.length}
            name={`total_files`}
          />

          {selectedFiles.map((value, index) => {
            return (
              <div className="text-white flex">
                <div className="w-3/12">
                  <InputText
                    name={`${index}-name`}
                    key={`${index}-name`}
                    label="Name"
                    type="text"
                    isRequired={true}
                    onChange={(e) => {
                      setFilesData('name', e, index)
                    }}
                    value={value.name}
                  />
                </div>
                <div className="w-3/12">
                  <InputText
                    name={`${index}-abbreviation`}
                    key={`${index}-abbreviation`}
                    label="Abbreviation"
                    type="text"
                    isRequired={true}
                    onChange={(e) => {
                      setFilesData('abbreviation', e, index)
                    }}
                    value={value.abbreviation}
                  />
                </div>
                <div className="w-3/12">
                  <TextArea
                    name={`${index}-description`}
                    key={`${index}-description`}
                    label="Description"
                    isRequired={true}
                    onChange={(e) => {
                      setFilesData('description', e, index)
                    }}
                    value={value.description}
                  />
                </div>
                <div className="w-3/12">
                  <FileField
                    key={`${index}-capital_harness_files`}
                    label="Capital Harness File"
                    name={`${index}-capital_harness_files`}
                    isRequired={true}
                    onChange={(e) => {
                      setFilesData(
                        'capital_harness_files',
                        e.target.value,
                        index
                      )
                    }}
                    value={value.def_file}
                    accept="text/xml"
                  />
                </div>

                {index != 0 && selectedFiles.length - 1 == index && (
                  <XCircle
                    className={'text-red-500 mr-3 cursor-pointer'}
                    size="2rem"
                    onClick={() => {
                      removeSelected(index)
                    }}
                  />
                )}
              </div>
            )
          })}

          <div className="flex justify-end text-blue-100">
            <span
              onClick={() => {
                let tempData = [...selectedFiles]
                tempData.push({
                  capital_harness_files: null,
                  id: Math.random(),
                  name: null,
                  description: null,
                  abbreviation: null,
                })
                setSelectedFiles(tempData)
              }}
              className="underline cursor-pointer"
            >
              {' '}
              Add More Files
            </span>
          </div>

          <div className="flex justify-end">
            <div className="w-auto">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 w-full justify-end`}
                onClick={(e) => {}}
                value={'text'}
                text={'Save And Process'}
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default CapitalHarnessForm
